// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#firstDeleteBulkModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#firstDeleteBulkModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#firstDeleteBulkModal .modal-dialog {
  max-width: 600px;
}
@media (min-width: 2024px) {
#firstDeleteBulkModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#firstDeleteBulkModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
